import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import ViewerRecord from '../records/ViewerRecord';
import { checkForAuth } from '../api/HubSpotAuthApi';
import { isChirpEnabled } from 'documents-lib/js/utils/isChirpEnabled';
export const useRequiresViewerInfo = () => {
  const [requiresViewerInfo, setRequiresViewerInfo] = useState(null);
  const [isRequested, setIsRequested] = useState(false);
  const {
    view,
    legalConsent
  } = useSelector(state => state);
  const {
    legalConsent: legalConsentRecord,
    legalConsentFailed
  } = legalConsent;
  const {
    presentation
  } = view.presentation;
  const cachedViewer = ViewerRecord.getFromCache();
  const isViewerCached = cachedViewer && ViewerRecord.hasEmail(cachedViewer);
  const isLoading = !legalConsentRecord && !legalConsentFailed || !presentation;
  useEffect(() => {
    if (isLoading || requiresViewerInfo !== null || isRequested) return;
    if (legalConsentFailed || isViewerCached) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setRequiresViewerInfo(false);
      return;
    } else if (legalConsentRecord.deckLegalConsentEnabled) {
      setRequiresViewerInfo(true);
      return;
    }
    if (presentation.skipForm || !presentation.hasActivity) {
      setRequiresViewerInfo(false);
      return;
    }
    setIsRequested(true);
    checkForAuth().then(() => {
      setRequiresViewerInfo(false);
    }, () => {
      setRequiresViewerInfo(true);
    }).catch(err => {
      throw err;
    });
  }, [isLoading, requiresViewerInfo, isRequested, legalConsentFailed, isViewerCached, presentation, legalConsentRecord]);
  return requiresViewerInfo;
};
export const useRequiresViewerInfoCHIRP = () => {
  const [requiresViewerInfo, setRequiresViewerInfo] = useState(null);
  const [isRequested, setIsRequested] = useState(false);
  const {
    view,
    legalConsent
  } = useSelector(state => state);
  const {
    legalConsentFailed,
    legalConsentCHIRP
  } = legalConsent;
  const cachedViewer = ViewerRecord.getFromCache();
  const isViewerCached = cachedViewer && ViewerRecord.hasEmail(cachedViewer);
  const {
    sharedLink
  } = view.presentation;
  const isLoading = !legalConsentCHIRP && !legalConsentFailed || !sharedLink;
  const isUngatedToChirp = isChirpEnabled();
  useEffect(() => {
    if (isLoading || requiresViewerInfo !== null || isRequested || !isUngatedToChirp) return;
    const isLegalConsentEnabled = legalConsentCHIRP === null || legalConsentCHIRP === void 0 ? void 0 : legalConsentCHIRP.documentLegalConsentEnabled;
    if (legalConsentFailed || isViewerCached) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setRequiresViewerInfo(false);
      return;
    } else if (isLegalConsentEnabled) {
      setRequiresViewerInfo(true);
      return;
    }
    if (sharedLink !== null && sharedLink !== void 0 && sharedLink.skipForm || !(sharedLink !== null && sharedLink !== void 0 && sharedLink.hasActivity)) {
      setRequiresViewerInfo(false);
      return;
    }
    setIsRequested(true);
    checkForAuth().then(() => {
      setRequiresViewerInfo(false);
    }, () => {
      setRequiresViewerInfo(true);
    }).catch(err => {
      throw err;
    });
  }, [isLoading, requiresViewerInfo, isRequested, legalConsentFailed, isViewerCached, legalConsentCHIRP === null || legalConsentCHIRP === void 0 ? void 0 : legalConsentCHIRP.documentLegalConsentEnabled, sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.hasActivity, sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.skipForm, isUngatedToChirp]);
  return requiresViewerInfo;
};